export class ArticleRotationResult {

  public rotatedArticleUsageIds: string[] = [];
  public groupedRotation: boolean = false;
  public allArticlesRotated: boolean = false;
}
